module.exports = __webpack_public_path__ + "img/hero.fd2600cf.png";